export default {
  'claimCount': 'Nombre de Réclamations',
  'totalClaimsCompletedByDayMonth': 'Total des Réclamations Traitées par Jour/Mois',
  'byMonthAndStatus': 'Réclamations par Mois et Statut',
};